/**
 * Worksheet cover palette.
 *
 * Each entry maps to a colorScheme value (0–9) stored on the question pack
 * document. The same palette is used by the UI bookshelf and the PDF generator
 * so covers always match.
 *
 * icon   — emoji shown in the white badge on the UI book card
 * symbol — ASCII fallback used in the PDF (reportlab Helvetica has no emoji)
 */
export const COVER_PALETTE = [
  { bg: '#1d4ed8', light: '#eff6ff', text: '#1e3a8a', icon: '🔢', symbol: '#'    }, // 0 blue
  { bg: '#0d9488', light: '#f0fdfa', text: '#0f766e', icon: '➕', symbol: '+'    }, // 1 teal
  { bg: '#16a34a', light: '#f0fdf4', text: '#14532d', icon: '½',  symbol: '1/2'  }, // 2 green
  { bg: '#d97706', light: '#fffbeb', text: '#78350f', icon: '%',  symbol: '%'    }, // 3 amber
  { bg: '#7c3aed', light: '#f5f3ff', text: '#4c1d95', icon: '𝑥',  symbol: 'x'   }, // 4 violet
  { bg: '#e11d48', light: '#fff1f2', text: '#881337', icon: '△',  symbol: 'D'    }, // 5 rose
  { bg: '#ea580c', light: '#fff7ed', text: '#7c2d12', icon: '📐', symbol: '<>'   }, // 6 orange
  { bg: '#0284c7', light: '#f0f9ff', text: '#0c4a6e', icon: '📊', symbol: '%'    }, // 7 sky
  { bg: '#db2777', light: '#fdf2f8', text: '#831843', icon: '∞',  symbol: 'oo'   }, // 8 pink
  { bg: '#4338ca', light: '#eef2ff', text: '#312e81', icon: 'f',  symbol: 'f(x)' }, // 9 indigo
  { bg: '#a538ca', light: '#eef2ff', text: '#0b0858', icon: '0.1',  symbol: '0.1' }, // 10 purple
  { bg: '#0f766e', light: '#f0fdfa', text: '#042f2e', icon: '1,2,3',   symbol: '1,2,3..'   }, // 11 dark-teal
  { bg: '#b45309', light: '#fffbeb', text: '#451a03', icon: '∑',   symbol: 'S'    }, // 12 brown-amber
  { bg: '#be123c', light: '#fff1f2', text: '#4c0519', icon: '÷',   symbol: '/'    }, // 13 crimson
  { bg: '#065f46', light: '#ecfdf5', text: '#022c22', icon: '∠',   symbol: 'A'    }, // 14 emerald
  { bg: '#6d28d9', light: '#f5f3ff', text: '#2e1065', icon: 'π',   symbol: 'pi'   }, // 15 deep-violet
  { bg: '#1e40af', light: '#eff6ff', text: '#1e3a8a', icon: '²',   symbol: '^2'   }, // 16 dark-blue
  { bg: '#c2410c', light: '#fff7ed', text: '#7c2d12', icon: '⚖',   symbol: '='    }, // 17 burnt-orange
  { bg: '#374151', light: '#f9fafb', text: '#111827', icon: '∗',   symbol: '*'    }, // 18 slate
  { bg: '#0369a1', light: '#f0f9ff', text: '#0c4a6e', icon: '≈',   symbol: '~'    }, // 19 ocean
];

/**
 * Returns the cover colour set for a given colorScheme value.
 * Accepts a number or string (as stored on the pack document).
 *
 * @param {number|string} colorScheme  value of pack.colorScheme (0–9)
 */
export function packCover(colorScheme) {
  const idx = parseInt(colorScheme, 10);
  const i   = isNaN(idx) ? 0 : idx % COVER_PALETTE.length;
  return COVER_PALETTE[i];
}
